export const REDIRECT = 'UTIL:REDIRECT';
export const SET_TABLE_HEIGHT = 'UTIL:SET_TABLE_HEIGHT';
